import React from 'react';
import { Container } from 'bootstrap-4-react';

import { BrowserRouter as Router, Link } from "react-router-dom";


class Header extends React.Component
{
    
    constructor() {
        super();
        let windowMenu = 'visible';
        let initial = "open";
        this.state = {
            WindowSize : window.innerWidth,
        }
        if (this.state.WindowSize < 991) {
            windowMenu = 'hidden';
            initial = '';
        }
        this.state = {
            menuStatus : windowMenu,
            burgerIcon: initial,
            companyStatus: '',
            solutionsStatus: '',
            portfolioStatus: '',
            companyIcon: 'down',
            solutionsIcon: 'down',
            portfolioIcon: 'down'
        }
        this.openMenu = this.openMenu.bind(this);
        this.openCompanySubmenu = this.openCompanySubmenu.bind(this);
        this.openPortfolioSubmenu = this.openPortfolioSubmenu.bind(this);
        this.openSolutionsSubmenu = this.openSolutionsSubmenu.bind(this);
    }
    
    openMenu() {
        if (this.state.menuStatus === 'hidden') {
            this.setState({
                menuStatus: "visible",
                burgerIcon: "open"
            });
        } else {
            this.setState({
                menuStatus: "hidden",
                burgerIcon: ''
              });
        }
        
    }
    openCompanySubmenu() {
        if (this.state.companyStatus === '') {
            this.setState({
                companyStatus: "visible",
                companyIcon: "up",
                solutionsStatus: "",
                solutionsIcon: 'down',
                portfolioStatus: "",
                portfolioIcon: 'down'
            });
        } else {
            this.setState({
                companyStatus: "",
                companyIcon: 'down'
              });
        }
        
    }
    openSolutionsSubmenu() {
        if (this.state.solutionsStatus === '') {
            this.setState({
                solutionsStatus: "visible",
                solutionsIcon: "up",
                companyStatus: "",
                companyIcon: 'down',
                portfolioStatus: "",
                portfolioIcon: 'down'
            });
        } else {
            this.setState({
                solutionsStatus: "",
                solutionsIcon: 'down',
              });
        }
        
    }
    openPortfolioSubmenu() {
        if (this.state.portfolioStatus === '') {
            this.setState({
                portfolioStatus: "visible",
                portfolioIcon: "up",
                solutionsStatus: "",
                solutionsIcon: 'down',
                companyStatus: "",
                companyIcon: 'down'
            });
        } else {
            this.setState({
                portfolioStatus: "",
                portfolioIcon: 'down',
              });
        }
        
    }
    render() {
        let menuClass = "menu hidden";
        if (this.state.menuStatus === 'visible') {
            menuClass = "menu visible";
        }
        
        let nav = <nav className="main-nav">
                        <div className={menuClass}>
                            <ul className="navigation" >
                                <li><Link to="/">Home</Link></li>
                                <li>
                                    <span onClick={this.openCompanySubmenu}>Company<i className={'fa fa-chevron-' + this.state.companyIcon}></i></span>
                                    <ul className={"submenu " + this.state.companyStatus} style={{ width: '150px'}}>
                                        <li><Link to="/aboutus">About Us</Link></li>
                                        <li><Link to="/team">Our Team</Link></li>
                                        <li><Link to="/careers/">Careers</Link></li>
                                    </ul>    
                                </li>
                                <li>
                                    <span to=""  onClick={this.openSolutionsSubmenu}>Solutions<i className={'fa fa-chevron-' + this.state.solutionsIcon}></i></span>
                                    <ul className={"submenu " + this.state.solutionsStatus} style={{ width: '220px'}}>
                                        <li><Link to="/omni-channel/">Omnichannel</Link></li>
                                        <li><Link to="/data-innovation">Data Innovation</Link></li>
                                        <li><Link to="/data-analytics">Data Analytics</Link></li>
                                        <li><Link to="/products/">Products</Link></li>
                                        <li><Link to="/demographics/">Demographics</Link></li>
                                    </ul>        
                                </li>
                                <li>
                                    <span to="" onClick={this.openPortfolioSubmenu}>Case studies<i className={'fa fa-chevron-' + this.state.portfolioIcon}></i></span>
                                    <ul className={"submenu " + this.state.portfolioStatus} style={{ width: '150px'}}>
                                        <li><Link to="/case-studies/">Projects</Link></li>
                                        <li><Link to="/presence/">Presence</Link></li>
                                    </ul>    
                                </li>
                                <li><Link to="/contact/">Contact</Link></li>
                            </ul>
                        </div>
                        <div id="nav-icon4" onClick={this.openMenu} className={this.state.burgerIcon}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </nav>;
        
        return (
            <header id='moobi-header'>
                <Container>
                    <h1 className="logo"><a href="/"></a></h1>
                    {nav}
                </Container>
            </header>
        )
    }
}
export default Header;
